import React from 'react'
import './Alerta.scss'

// https://reactstrap.github.io/components/popovers/
import { UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap'

class Alerta extends React.Component {
    constructor(props) {
        super(props)
        this.state = { isOpen: props.isOpen }
        this.toggle = this.toggle.bind(this)
    }

    componentDidUpdate(previousProps, previousState) {
        if (this.props.isOpen !== previousProps.isOpen) {
            this.setState({
                isOpen: this.props.isOpen,
            })
        }
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen,
        })
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    render() {
        return (
            <UncontrolledPopover
                {...this.props}
                isOpen={this.state.isOpen}
                placement={!this.props.placement ? this.props.placement : 'bottom'}
                className="toolTipAlerta"
            >
                <PopoverHeader className="headerToolTipAlerta">
                    {this.props.titulo}
                    <button onClick={this.toggle}>X</button>
                </PopoverHeader>
                <PopoverBody className="bodyToolTipAlerta">{this.props.mensagem}</PopoverBody>
            </UncontrolledPopover>
        )
    }
}

export default Alerta
